export var apiPath='/v1/custom_roles';var actionType='V2_ROLES';export var bulkActionType="".concat(actionType,"_BULK");export default actionType;